export const toggleState = (key, value, setState) =>
  setState((prevState) => ({
    ...prevState,
    [key]: value,
  }));

export const renderIf = (condition, component) =>(condition ? component : null)